import {
  BarChart3,
  Building2,
  FolderKanban,
  Layout,
  Share2,
  User,
  type LucideIcon,
} from "lucide-react";

export interface CmsModuleDef {
  id: string;
  label: string;
  description: string;
  to: string;
  icon: LucideIcon;
  searchable: string[];
}

export const CMS_MODULES: CmsModuleDef[] = [
  {
    id: "homepage",
    label: "Homepage",
    description: "Featured projects, stats and hero CTA",
    to: "/cms/homepage",
    icon: Layout,
    searchable: ["homepage", "featured", "hero", "stats", "our work"],
  },
  {
    id: "portfolio",
    label: "Portfolio",
    description: "Case studies and project showcases",
    to: "/cms/portfolio",
    icon: FolderKanban,
    searchable: ["portfolio", "case study", "projects", "clients"],
  },
  {
    id: "founder",
    label: "Founder",
    description: "Founder profile and biography",
    to: "/cms/founder",
    icon: User,
    searchable: ["founder", "ceo", "bio", "profile"],
  },
  {
    id: "company",
    label: "Company Information",
    description: "Contact details and business hours",
    to: "/cms/company",
    icon: Building2,
    searchable: ["company", "address", "email", "phone", "contact"],
  },
  {
    id: "social",
    label: "Social Media",
    description: "Social profile links and visibility",
    to: "/cms/social",
    icon: Share2,
    searchable: ["social", "linkedin", "instagram", "twitter"],
  },
  {
    id: "analytics",
    label: "Visitor Analytics",
    description: "Traffic, visitors and form submissions",
    to: "/cms/analytics",
    icon: BarChart3,
    searchable: ["analytics", "visitors", "traffic", "page views"],
  },
];

export function getCmsModuleByPath(pathname: string) {
  if (pathname === "/cms") return null;
  return CMS_MODULES.find((m) => pathname === m.to || pathname.startsWith(`${m.to}/`)) ?? null;
}
